export default __webpack_public_path__ + "static/media/edit.cc5ddcfa.svg";